//  Dependencies

import React, { Component } from 'react';
import Divider from '../Divider/Divider';

// Style

import './Header.css';

const Header = (props) => {
  return (
    <heading className="header">
      <img style={{ 'display': `${props.displayIcon}` }} alt="Header Icon" className="header__icon" src={props.icon} />
      <div className="header__heading">
        <h1>{props.heading}</h1>
      </div>
      <div style={{ 'display': `${props.displayDivider}` }}>
        <Divider />
      </div>
      <p style={{ 'display': `${props.displayText}` }}>{props.text}</p>
    </heading>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/Header/Header.js